(function () {
  var lockedScrollValue = null;

  function lockPageScroll() {
    if (lockedScrollValue !== null) return;
    lockedScrollValue = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }

  function unlockPageScroll() {
    if (lockedScrollValue === null) return;
    document.body.style.overflow = lockedScrollValue;
    lockedScrollValue = null;
  }

  function getVisibleCards(section) {
    return Array.from(section.querySelectorAll('[data-xeela-workouts-card]:not([hidden])'));
  }

  function updateProgress(section) {
    var track = section.querySelector('[data-xeela-workouts-track]');
    var progress = section.querySelector('[data-xeela-workouts-progress]');
    if (!track || !progress) return;

    var maxScroll = track.scrollWidth - track.clientWidth;
    var visibleCards = getVisibleCards(section);
    if (maxScroll <= 1 || visibleCards.length <= 1) {
      progress.style.width = '100%';
      updateControls(section, true, true);
      return;
    }

    var percent = ((track.scrollLeft + track.clientWidth) / track.scrollWidth) * 100;
    progress.style.width = Math.max(12, Math.min(100, percent)) + '%';
    updateControls(section, track.scrollLeft <= 2, track.scrollLeft >= maxScroll - 2);
  }

  function updateControls(section, atStart, atEnd) {
    var prev = section.querySelector('[data-xeela-workouts-prev]');
    var next = section.querySelector('[data-xeela-workouts-next]');
    if (prev) prev.disabled = !!atStart;
    if (next) next.disabled = !!atEnd;
  }

  function setCategory(section, category) {
    var track = section.querySelector('[data-xeela-workouts-track]');
    section.querySelectorAll('[data-xeela-workouts-tab]').forEach(function (tab) {
      var active = tab.dataset.xeelaWorkoutsTab === category;
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    section.querySelectorAll('[data-xeela-workouts-card]').forEach(function (card) {
      var active = card.dataset.xeelaWorkoutsCategory === category;
      card.hidden = !active;
      card.setAttribute('aria-hidden', active ? 'false' : 'true');
      card.querySelectorAll('a, button').forEach(function (control) {
        control.tabIndex = active ? 0 : -1;
      });
    });

    if (track) track.scrollLeft = 0;
    window.requestAnimationFrame(function () {
      updateProgress(section);
    });
  }

  function scrollTrack(section, direction) {
    var track = section.querySelector('[data-xeela-workouts-track]');
    var firstCard = section.querySelector('[data-xeela-workouts-card]:not([hidden])');
    if (!track || !firstCard) return;

    var styles = window.getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap || 0);
    var distance = firstCard.getBoundingClientRect().width + gap;
    track.scrollBy({ left: direction * distance, behavior: 'smooth' });
  }

  function closeModal(section) {
    var modal = section.querySelector('[data-xeela-workouts-modal]');
    var video = section.querySelector('[data-xeela-workouts-modal-video]');
    if (!modal) return;

    if (video) {
      video.pause();
      try {
        video.currentTime = 0;
      } catch (error) {
        // Some remote media sources disallow seeking until metadata is loaded.
      }
      video.removeAttribute('src');
      video.load();
    }

    modal.hidden = true;
    modal.classList.remove('is-open');
    delete section.dataset.xeelaWorkoutsModalOpen;
    unlockPageScroll();
  }

  function openModal(section, videoUrl) {
    var modal = section.querySelector('[data-xeela-workouts-modal]');
    var video = section.querySelector('[data-xeela-workouts-modal-video]');
    var closeButton = section.querySelector('.xeela-home-workouts__modal-close');
    if (!modal || !video || !videoUrl) return;

    video.pause();
    video.removeAttribute('src');
    video.load();
    video.src = videoUrl;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    modal.hidden = false;
    modal.classList.add('is-open');
    section.dataset.xeelaWorkoutsModalOpen = 'true';
    lockPageScroll();

    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }

    if (closeButton) closeButton.focus();
  }

  function teardownSection(section) {
    closeModal(section);

    if (section.xeelaWorkoutsResizeHandler) {
      window.removeEventListener('resize', section.xeelaWorkoutsResizeHandler);
      delete section.xeelaWorkoutsResizeHandler;
    }

    if (section.xeelaWorkoutsKeydownHandler) {
      document.removeEventListener('keydown', section.xeelaWorkoutsKeydownHandler);
      delete section.xeelaWorkoutsKeydownHandler;
    }

    delete section.dataset.xeelaWorkoutsInitialized;
  }

  function initSection(section) {
    if (!section || section.dataset.xeelaWorkoutsInitialized === 'true') return;
    section.dataset.xeelaWorkoutsInitialized = 'true';

    var tabs = Array.from(section.querySelectorAll('[data-xeela-workouts-tab]'));
    var activeTab = tabs.find(function (tab) {
      return tab.getAttribute('aria-selected') === 'true';
    }) || tabs[0];
    var activeCategory = activeTab ? activeTab.dataset.xeelaWorkoutsTab : 'transformation';

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        setCategory(section, tab.dataset.xeelaWorkoutsTab);
      });
    });

    var track = section.querySelector('[data-xeela-workouts-track]');
    if (track) {
      track.dataset.xeelaWorkoutsReady = 'true';
      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(function () {
          updateProgress(section);
        });
      }, { passive: true });
    }

    var prev = section.querySelector('[data-xeela-workouts-prev]');
    var next = section.querySelector('[data-xeela-workouts-next]');
    if (prev) prev.addEventListener('click', function () { scrollTrack(section, -1); });
    if (next) next.addEventListener('click', function () { scrollTrack(section, 1); });

    section.querySelectorAll('[data-xeela-workouts-video]').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        openModal(section, button.dataset.xeelaWorkoutsVideo);
      });
    });

    section.querySelectorAll('[data-xeela-workouts-close]').forEach(function (control) {
      control.addEventListener('click', function () {
        closeModal(section);
      });
    });

    section.xeelaWorkoutsKeydownHandler = function (event) {
      if (event.key === 'Escape' && section.dataset.xeelaWorkoutsModalOpen === 'true') {
        closeModal(section);
      }
    };
    document.addEventListener('keydown', section.xeelaWorkoutsKeydownHandler);

    section.xeelaWorkoutsResizeHandler = function () {
      updateProgress(section);
    };
    window.addEventListener('resize', section.xeelaWorkoutsResizeHandler);

    setCategory(section, activeCategory);
  }

  function getSections(root) {
    var scope = root || document;
    var sections = [];
    if (scope.matches && scope.matches('[data-xeela-home-workouts]')) {
      sections.push(scope);
    }
    scope.querySelectorAll('[data-xeela-home-workouts]').forEach(function (section) {
      sections.push(section);
    });
    return sections;
  }

  function initAll(root) {
    getSections(root).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    getSections(event.target).forEach(teardownSection);
  });
})();
